
import React from 'react';
import { Task } from '@/context/TaskContext';
import FloatingActionButtons from '@/components/ui/floating-action-buttons';

interface TaskListModalFABsProps {
  isOpen: boolean;
  isAuthenticated: boolean;
  activeListId: string | null;
  activeTask: Task | null;
  mainTab: string;
  showPriorityMatrix: boolean;
  onCreateTask: () => void;
  onStartFocus: () => void;
  onShowTaskLimitNudge: () => void;
  canCreateTask: boolean;
}

const TaskListModalFABs: React.FC<TaskListModalFABsProps> = ({
  isOpen,
  isAuthenticated,
  activeListId,
  activeTask,
  mainTab,
  showPriorityMatrix,
  onCreateTask,
  onStartFocus,
  onShowTaskLimitNudge,
  canCreateTask
}) => {
  // Show FABs only when in "tasks" tab and not priority matrix
  const canShowFAB = mainTab === 'tasks' && activeListId && !showPriorityMatrix;

  // If modal closed or not on list tab, hide
  if (!isOpen || !canShowFAB) {
    return null;
  }

  // Smart FAB mode: If a task is selected, show split FAB, else just create
  const splitMode = !!activeTask;

  const handleStartFocus = () => {
    onStartFocus();
  };

  return (
    <FloatingActionButtons
      onCreateTask={onCreateTask}
      onStartFocus={handleStartFocus}
      showStartFocus={!!activeTask}
      splitMode={splitMode}
      onShowTaskLimitNudge={onShowTaskLimitNudge}
      canCreateTask={canCreateTask}
    />
  );
};

export default TaskListModalFABs;
